import { Heading, Grid, GridColumn } from '@fairygodboss/ui';
import React from 'react';

export const ContentTitle = ({ contentTitle }) => (
    <Grid css={{ maxWidth: '100%' }}>
        <GridColumn
            size={{
                _: 12,
                sm: 12,
                md: 11,
                lg: 11,
            }}
        >
            <style jsx>
                {`
                    a {
                        textdecoration: "none";
                    }
                `}
            </style>
            <Heading variant={{ _: 'headingLg', md: 'heading2xl' }} as="h1">
                {contentTitle}
            </Heading>
        </GridColumn>
    </Grid>
);

ContentTitle.displayName = 'ContentTitle';
